var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "", "align-center": "" } },
                    [
                      _c("v-flex", { attrs: { xs2: "" } }, [
                        _c(
                          "h3",
                          { staticClass: "headline mb-0 admin-header" },
                          [_vm._v("Endpoints")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs2: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                text: "",
                                icon: "",
                                color: "grey lighten-1",
                              },
                              on: { click: _vm.refreshList },
                            },
                            [_c("v-icon", [_vm._v("fas fa-sync")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              "append-icon": "fal fa-search",
                              placeholder: "Search",
                              "single-line": "",
                              "hide-details": "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.search,
                              callback: function ($$v) {
                                _vm.search = $$v
                              },
                              expression: "search",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs1: "" } },
                        [
                          _c(
                            "v-dialog",
                            {
                              attrs: { "max-width": "1000px" },
                              model: {
                                value: _vm.deletedEndpointsDialog,
                                callback: function ($$v) {
                                  _vm.deletedEndpointsDialog = $$v
                                },
                                expression: "deletedEndpointsDialog",
                              },
                            },
                            [
                              _vm.deletedEndpointsDialog
                                ? _c("deleted-endpoints", {
                                    on: {
                                      endpointUnDeleted: _vm.refreshList,
                                      endpointsUnDeleted: _vm.refreshList,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.deletedEndpointsDialog = true
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "20",
                                                color: "grey lighten-1",
                                              },
                                            },
                                            [_vm._v("far fa-recycle")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _vm._v(" "),
                              _c("span", [_vm._v("Manage Recycle Bin")]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs3: "" } }, [_c("p")]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs3: "" } },
                        [
                          _c("v-checkbox", {
                            attrs: { label: "Show ExternalId" },
                            on: { change: _vm.toggleExternalId },
                            model: {
                              value: _vm.showExternalId,
                              callback: function ($$v) {
                                _vm.showExternalId = $$v
                              },
                              expression: "showExternalId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs3: "", "pr-5": "" } },
                        [
                          _c("v-select", {
                            attrs: {
                              label: "Select statuses",
                              items: _vm.statuses,
                              multiple: "",
                              clearable: "",
                              "small-chips": "",
                              "deletable-chips": "",
                            },
                            model: {
                              value: _vm.selectedStatuses,
                              callback: function ($$v) {
                                _vm.selectedStatuses = $$v
                              },
                              expression: "selectedStatuses",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs3: "", "pr-5": "" } },
                        [
                          _c("v-select", {
                            attrs: {
                              label: "Select monitoring groups",
                              multiple: "",
                              items: _vm.accessGroups,
                              "item-text": "name",
                              "item-value": "id",
                              clearable: "",
                              "small-chips": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "selection",
                                fn: function ({ item, index }) {
                                  return [
                                    index < 2
                                      ? _c("v-chip", [
                                          _vm._v(_vm._s(item.name)),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    index === 2
                                      ? _c(
                                          "span",
                                          { staticClass: "grey--text caption" },
                                          [
                                            _vm._v(
                                              "(+" +
                                                _vm._s(
                                                  _vm.selectedAccessGroups
                                                    .length - 2
                                                ) +
                                                " items)"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.selectedAccessGroups,
                              callback: function ($$v) {
                                _vm.selectedAccessGroups = $$v
                              },
                              expression: "selectedAccessGroups",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs3: "", "pr-5": "" } },
                        [
                          _c("v-select", {
                            attrs: {
                              label: "Select auth statuses",
                              multiple: "",
                              items: _vm.credStatuses,
                              clearable: "",
                              "small-chips": "",
                              "deletable-chips": "",
                            },
                            model: {
                              value: _vm.selectedCredStatuses,
                              callback: function ($$v) {
                                _vm.selectedCredStatuses = $$v
                              },
                              expression: "selectedCredStatuses",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-dialog",
                {
                  attrs: { "max-width": "600px" },
                  model: {
                    value: _vm.dialog,
                    callback: function ($$v) {
                      _vm.dialog = $$v
                    },
                    expression: "dialog",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-title", [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v("Endpoint"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-form",
                            {
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                },
                              },
                              model: {
                                value: _vm.validEp,
                                callback: function ($$v) {
                                  _vm.validEp = $$v
                                },
                                expression: "validEp",
                              },
                            },
                            [
                              _c(
                                "v-container",
                                { attrs: { "grid-list-md": "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs12: "", sm6: "", md6: "" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              rules: [_vm.rules.required],
                                              label: "Name",
                                            },
                                            model: {
                                              value: _vm.editedItem.name,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "name",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs12: "", sm6: "", md6: "" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              rules: [_vm.rules.required],
                                              label: "Host Address",
                                            },
                                            model: {
                                              value: _vm.editedItem.hostAddress,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "hostAddress",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.hostAddress",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-flex", { attrs: { xs12: "" } }, [
                                        _vm._v(
                                          "\n                    Aliases:\n                  "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs4: "", sm4: "", md4: "" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "SIP" },
                                            model: {
                                              value:
                                                _vm.editedItem.aliasInfo.sip,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem.aliasInfo,
                                                  "sip",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.aliasInfo.sip",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs4: "", sm4: "", md4: "" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "H323" },
                                            model: {
                                              value:
                                                _vm.editedItem.aliasInfo.h323,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem.aliasInfo,
                                                  "h323",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.aliasInfo.h323",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs4: "", sm4: "", md4: "" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "E164" },
                                            model: {
                                              value:
                                                _vm.editedItem.aliasInfo.e164,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem.aliasInfo,
                                                  "e164",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.aliasInfo.e164",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs12: "", sm6: "", md6: "" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "Login" },
                                            model: {
                                              value: _vm.editedItem.login,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "login",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.login",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs12: "", sm6: "", md6: "" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              type: "password",
                                              label: "Password",
                                            },
                                            model: {
                                              value: _vm.editedItem.password,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "password",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.password",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            xs12: "",
                                            sm12: "",
                                            md12: "",
                                          },
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.accessGroups,
                                              "item-text":
                                                _vm.getAccessGroupName,
                                              "item-value": "id",
                                              "menu-props": {
                                                maxHeight: "400",
                                              },
                                              label: "Monitoring Groups",
                                              multiple: "",
                                              disabled: "",
                                              hint: "Monitoring Groups can be edited from the Monitoring Groups view",
                                              "persistent-hint": "",
                                            },
                                            model: {
                                              value:
                                                _vm.editedItem.accessGroups,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "accessGroups",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.accessGroups",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs12: "", sm6: "", md6: "" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              disabled: "",
                                              label: "External Id",
                                            },
                                            model: {
                                              value: _vm.editedItem.externalId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "externalId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.externalId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.isSU || _vm.isProfessional
                                        ? _c(
                                            "v-flex",
                                            { attrs: { xs10: "" } },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.editedItem.miscData
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isSU
                                        ? _c(
                                            "v-flex",
                                            { attrs: { xs2: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: { text: "", icon: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.doCopy(
                                                        _vm.editedItem
                                                          .miscDataJson
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("fas fa-copy"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _vm.hasMonitor(_vm.editedItem) &&
                          _vm.editedItem.accessGroups.length &&
                          _vm.editedItem.login &&
                          _vm.editedItem.password
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { text: "", color: "orange" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.validateEndpoint()
                                    },
                                  },
                                },
                                [_vm._v("Validate")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", color: "blue darken-1" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.close.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v("Cancel")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                text: "",
                                color: "blue darken-1",
                                disabled: !_vm.validEp,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.save.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v("Save")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-data-table",
                {
                  staticClass: "endpointsList elevation-1",
                  attrs: {
                    options: _vm.pagination,
                    "footer-props": {
                      "items-per-page-options": _vm.rowsPerPageItems,
                    },
                    headers: _vm.headers,
                    items: _vm.filteredEndpoints,
                    expanded: _vm.expandedItems,
                    search: _vm.search,
                    loading: _vm.loading,
                    "show-select": "",
                  },
                  on: {
                    "update:options": function ($event) {
                      _vm.pagination = $event
                    },
                    "update:expanded": function ($event) {
                      _vm.expandedItems = $event
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "headerCell",
                      fn: function (props) {
                        return [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(props.header.text) +
                                              "\n          "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      props.header.tooltip || props.header.text
                                    ) +
                                    "\n        "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.id",
                      fn: function ({ item }) {
                        return [
                          _vm.isProfessional || _vm.isSU
                            ? _c("td", [_vm._v(_vm._s(item.id))])
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "item.externalId",
                      fn: function ({ item }) {
                        return [
                          _vm.showExternalId
                            ? _c("td", [_vm._v(_vm._s(item.externalId))])
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "item.aliases",
                      fn: function ({ item }) {
                        return [
                          _c("td", [
                            _vm._v(_vm._s(_vm.getAliases(item.aliases))),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "item.name",
                      fn: function ({ item }) {
                        return [
                          _c(
                            "td",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: { to: "" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.editItem(item)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(item.name))]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.hostAddress",
                      fn: function ({ item }) {
                        return [
                          _c("td", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.formatHostAddress(item),
                                  target: "_blank",
                                },
                              },
                              [_vm._v(_vm._s(item.hostAddress))]
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "item.accessGroupString",
                      fn: function ({ item }) {
                        return [
                          _c(
                            "td",
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "", "max-width": "200px" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c("span", _vm._g({}, on), [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    item.accessGroupString ===
                                                      "vyopta_∞"
                                                      ? "(auto)"
                                                      : item.accessGroupSummary
                                                  ) +
                                                  "\n            "
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        item.accessGroupString === "vyopta_∞"
                                          ? "automatically added to default monitoring group"
                                          : item.accessGroupString
                                      ) +
                                      "\n        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.hasCredentials",
                      fn: function ({ item }) {
                        return [
                          _c("td", [
                            _vm._v(
                              "\n          " +
                                _vm._s(item.hasCredentials ? "✓" : "X") +
                                "\n      "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "item.actions",
                      fn: function ({ item }) {
                        return [
                          _c(
                            "td",
                            { staticClass: "actions" },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  staticStyle: {
                                                    height: "0px",
                                                    width: "0px",
                                                    "padding-right": "2px",
                                                  },
                                                  attrs: { text: "", icon: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.editItem(item)
                                                    },
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "18px",
                                                    },
                                                    attrs: {
                                                      color: "grey lighten-1",
                                                    },
                                                  },
                                                  [_vm._v("fas fa-pencil")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [_vm._v(" "), _c("span", [_vm._v("Edit")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  staticStyle: {
                                                    height: "0px",
                                                    width: "0px",
                                                  },
                                                  attrs: { text: "", icon: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.deleteEndpoint(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "18px",
                                                    },
                                                    attrs: {
                                                      color: "grey lighten-1",
                                                    },
                                                  },
                                                  [_vm._v("fas fa-trash")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [_vm._v(" "), _c("span", [_vm._v("Delete")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _vm.hasMonitor(item) &&
                                            item.accessGroupSummary
                                              ? _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      staticStyle: {
                                                        height: "0px",
                                                        width: "0px",
                                                        "padding-right": "2px",
                                                      },
                                                      attrs: {
                                                        text: "",
                                                        icon: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.validateEndpoint(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "18px",
                                                        },
                                                        attrs: {
                                                          color:
                                                            "grey lighten-1",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "fas fa-check-circle"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [_vm._v(" "), _c("span", [_vm._v("Validate")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _vm.hasAnyMonitor(item)
                                              ? _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      staticStyle: {
                                                        height: "0px",
                                                        width: "0px",
                                                        "padding-right": "2px",
                                                      },
                                                      attrs: {
                                                        text: "",
                                                        icon: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.validateEndpoint2(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "18px",
                                                        },
                                                        attrs: {
                                                          color:
                                                            "grey lighten-1",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "fal fa-check-circle"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [_vm._v(" "), _c("span", [_vm._v("Validate")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _vm.isSU && item.accessGroupSummary
                                              ? _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      staticStyle: {
                                                        height: "0px",
                                                        width: "0px",
                                                      },
                                                      attrs: {
                                                        text: "",
                                                        icon: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.editedId = item.id
                                                          _vm.expandItem(item)
                                                        },
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "18px",
                                                        },
                                                        attrs: {
                                                          color:
                                                            "grey lighten-1",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "fas fa-info-circle"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Realtime Data Feed")]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "expanded-item",
                      fn: function ({ headers, item }) {
                        return [
                          _c(
                            "td",
                            { attrs: { colspan: "13" } },
                            [
                              _c("endpoint-rt-logs", {
                                attrs: { srcIdFilter: item.id },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.selected,
                    callback: function ($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected",
                  },
                },
                [
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        slot: "no-results",
                        value: true,
                        color: "error",
                        type: "warning",
                      },
                      slot: "no-results",
                    },
                    [
                      _vm._v(
                        '\n        Your search for "' +
                          _vm._s(_vm.search) +
                          '" found no results.\n      '
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function ($event) {
                          return _vm.newItem()
                        },
                      },
                    },
                    [_vm._v("New Endpoint")]
                  ),
                  _vm._v(" "),
                  _vm.selected.length
                    ? _c(
                        "v-btn",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.changePassword()
                            },
                          },
                        },
                        [_vm._v("Set Password")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selected.length
                    ? _c(
                        "v-btn",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.deleteEndpoints()
                            },
                          },
                        },
                        [_vm._v("Delete")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v("\n      " + _vm._s(_vm.driverStatus) + "\n      "),
                  !_vm.collectorsNotFound
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            icon: "",
                            color: "grey lighten-1",
                            loading: _vm.loadingMonitors,
                          },
                          on: { click: _vm.refreshDrivers },
                        },
                        [_c("v-icon", [_vm._v("fas fa-sync")])],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-dialog",
                {
                  attrs: { "max-width": "600px" },
                  model: {
                    value: _vm.pwdChangeDialog,
                    callback: function ($$v) {
                      _vm.pwdChangeDialog = $$v
                    },
                    expression: "pwdChangeDialog",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-title", [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v(
                            "Set Password for Endpoints in Monitoring Group"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-form",
                            {
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                },
                              },
                              model: {
                                value: _vm.validPwd,
                                callback: function ($$v) {
                                  _vm.validPwd = $$v
                                },
                                expression: "validPwd",
                              },
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  rules: [_vm.rules.required],
                                  label: "Login",
                                },
                                model: {
                                  value: _vm.newLogin,
                                  callback: function ($$v) {
                                    _vm.newLogin = $$v
                                  },
                                  expression: "newLogin",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  rules: [_vm.rules.required],
                                  type: "password",
                                  label: "Password",
                                },
                                model: {
                                  value: _vm.newPassword,
                                  callback: function ($$v) {
                                    _vm.newPassword = $$v
                                  },
                                  expression: "newPassword",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  rules: [_vm.rules.match],
                                  type: "password",
                                  label: "Confirm Password",
                                },
                                model: {
                                  value: _vm.confirmPassword,
                                  callback: function ($$v) {
                                    _vm.confirmPassword = $$v
                                  },
                                  expression: "confirmPassword",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", color: "blue darken-1" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.closeBulkPasswordDialog.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_vm._v("Cancel")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                text: "",
                                color: "blue darken-1",
                                disabled: !_vm.validPwd,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.saveBulkPassword.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_vm._v("Save")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-dialog",
                {
                  attrs: { persistent: "", width: "500" },
                  model: {
                    value: _vm.endpointRemoteValidationDialog,
                    callback: function ($$v) {
                      _vm.endpointRemoteValidationDialog = $$v
                    },
                    expression: "endpointRemoteValidationDialog",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-title", { staticClass: "headline" }, [
                        _vm._v(_vm._s(_vm.endpointRemoteValidationStatus)),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _c("h3", [
                          _vm._v(_vm._s(_vm.endpointRemoteValidationMessage)),
                        ]),
                        _vm._v(" "),
                        _vm.endpointRemoteValidationMessages.length
                          ? _c(
                              "p",
                              [
                                _vm._v(
                                  "Details:\n                                "
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "" },
                                    nativeOn: {
                                      click: function ($event) {
                                        _vm.showErrDetails = !_vm.showErrDetails
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showErrDetails
                                            ? "fas fa-chevron-up"
                                            : "fas fa-chevron-down"
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showErrDetails
                          ? _c(
                              "div",
                              _vm._l(
                                _vm.endpointRemoteValidationMessages,
                                function (msg, i) {
                                  return _c("p", { key: i }, [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(msg) +
                                        "\n                        "
                                    ),
                                  ])
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", color: "orange" },
                              on: {
                                click: function ($event) {
                                  _vm.endpointRemoteValidationDialog = false
                                },
                              },
                            },
                            [_vm._v("Close")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-dialog",
                {
                  attrs: { persistent: "", width: "300" },
                  model: {
                    value: _vm.waitDialog,
                    callback: function ($$v) {
                      _vm.waitDialog = $$v
                    },
                    expression: "waitDialog",
                  },
                },
                [
                  _c(
                    "v-card",
                    { attrs: { color: "primary", dark: "" } },
                    [
                      _c(
                        "v-card-text",
                        [
                          _vm._v(
                            "\n                    Please stand by\n                    "
                          ),
                          _c("v-progress-linear", {
                            staticClass: "mb-0",
                            attrs: { indeterminate: "", color: "white" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }